import React from 'react';
import { Link } from '@tanstack/react-router';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
export function FeatureLocked({ title, description, plan, features = [], upgradePath = '/console/billing', }) {
    return (<Card className="border-dashed bg-muted/30">
            <CardHeader className="space-y-2">
                <div className="flex items-center gap-2 text-muted-foreground">
                    <Lock className="h-4 w-4"/>
                    <span className="text-xs uppercase tracking-wide">{plan} feature</span>
                </div>

                <CardTitle className="text-lg">{title}</CardTitle>
            </CardHeader>

            <CardContent className="space-y-4">
                <p className="text-sm text-muted-foreground">{description}</p>

                {features.length > 0 && (<ul className="space-y-1 text-sm text-muted-foreground list-disc pl-5">
                        {features.map((feature) => (<li key={feature}>{feature}</li>))}
                    </ul>)}

                <div className="pt-2">
                    <Button asChild>
                        <Link to={upgradePath}>Upgrade to {plan}</Link>
                    </Button>
                </div>
            </CardContent>
        </Card>);
}
